module.exports = __webpack_public_path__ + "static/random-shortcuts-logo-white-fe791db559cfd2dff7b01058b03caa91.svg";